import React, { useContext } from 'react';

import styled from '@emotion/styled';
import cn from 'classnames';

import { COLORS } from '@root/colors';
import { ISelection, Selector, Uploader } from '@shared/components/files';

import { Context } from './context';

const FlexContainer = styled.div`
  min-height: 44px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

const TruncatedText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${COLORS.grayDarker};
`;

const ChooseFileLabel = styled.label`
  && {
    padding: 8px 14px;
    margin-bottom: 0;
  }
`;

const UploadBar = styled(TruncatedText)`
  min-width: 144px;
`;

export const FileUploader: React.FC<{
  upload?: ISelection;
}> = ({ upload }) => {
  const { file, loading } = useContext(Context);

  return (
    <FlexContainer>
      <ChooseFileLabel className={cn('btn', 'btn-sm', 'btn-rounded', 'btn-default', { disabled: loading })}>
        <Selector multiple={false} accept=".csv" disabled={loading} />
        Choose File
      </ChooseFileLabel>
      {!upload && <TruncatedText>{file?.name}</TruncatedText>}
      <UploadBar>{upload && <Uploader key={upload.uuid} {...upload} />}</UploadBar>
    </FlexContainer>
  );
};
